import React, { useRef } from "react";
import ReactToPdf from "react-to-pdf";
import { useSelector } from "react-redux";
import { Button } from "reactstrap";
import Pdf from "./Pdf";

const GeneratePDF = ({ heading, isIb, t, fileUrl }) => {
  const {
    firstName,
    fx: { ibQuestionnaire },
  } = useSelector((state) => state.Profile.clientData);

  const pdfRef = useRef(null);

  const handlePdfRef = (ref) => {
    pdfRef.current = ref;
  };

  // ========= IF WE ALREADY HAVE A FILE URL → DOWNLOAD DIRECT FILE =========
  const handleDirectDownload = () => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = `${heading}.pdf`;
    link.click();
  };

  // ========= IF THERE IS A FILE URL — STOP AND JUST DOWNLOAD IT =========
  if (fileUrl) {
    return (
      <Button size="sm" color="primary" onClick={handleDirectDownload}>
        {t("Download")}
      </Button>
    );
  }

  // ========= OTHERWISE GENERATE PDF USING react-to-pdf =========
  return (
    <>
      <div className="hidden">
        <Pdf onPdfRef={handlePdfRef} heading={heading} isIb={isIb} toGenerate={true}/>
      </div>

      <ReactToPdf
        targetRef={pdfRef}
        filename={`${firstName}-${isIb ? "SubIb" : "Individual"}.pdf`}
        options={{
          orientation: "p",
          unit: "px",
          format: [1230, isIb && ibQuestionnaire ? 1800 : 1500],
        }}
        x={2}
        y={2}
        scale={1.5}
      >
        {({ toPdf }) => (
          <Button size="sm" color="primary" onClick={toPdf}>
            {t("Download")}
          </Button>
        )}
      </ReactToPdf>
    </>
  );
};

export default GeneratePDF;
